/**
 * Different types of Bar design
 * @public
 */
enum BarDesign {
	/**
	 * Default type
	 * @public
	 */
	Header = "Header",

	/**
	 * Subheader type
	 * @public
	 */
	Subheader = "Subheader",

	/**
	 * Footer type
	 * @public
	 */
	Footer = "Footer",

	/**
	 * Floating Footer type - there is visible border on all sides
	 * @public
	 */
	FloatingFooter = "FloatingFooter",
}

export default BarDesign;
